import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';

export interface FilterField {
  type: 'select' | 'multiselect' | 'text';
  label: string;
  name: string;
  placeholder?: string;
  options: any[];
  value: any;
  optionLabel?: string;
  optionValue?: string;
  maxSelectedLabels?: number;
  class?: string;
  onChange?: () => void;
}

@Component({
  selector: 'app-filter',
  imports: [ 
    TableModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    SelectModule,
    PanelModule,
    CheckboxModule,
    ButtonModule,
    MultiSelectModule,
    InputTextModule
  ],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent {
  @Input() fields: any[] = [];
  @Input() panelTitle: string = 'Filter';
  @Input() collapsed: boolean = false;

  @Output() collapsedChange = new EventEmitter<boolean>();
  @Output() apply = new EventEmitter<any>(); // Will emit filter values
  @Output() clear = new EventEmitter<void>();

  constructor() {}

  togglePanel(): void {
    this.collapsed = !this.collapsed;
  }

  // onFieldChange(field: any): void {
  //   // console.log('Field changed:', field.name, field.value);
  // }

  // Method to collect all current filter values
  getFilterValues(): any {
    const filterValues: any = {};
    
    this.fields.forEach(field => {
      if (field.value !== null && field.value !== undefined && field.value !== '') {
        // Handle array values (multiselect)
        if (Array.isArray(field.value) && field.value.length > 0) {
          filterValues[field.name] = field.value;
        }
        // Handle single values (select, text)
        else if (!Array.isArray(field.value)) {
          filterValues[field.name] = field.value;
        }
      }
    });
    
    return filterValues;
  }

  // Method called when Apply Filter button is clicked
  onApplyFilter(): void {
    const filterValues = this.getFilterValues();
    // console.log('Applying filters with values:', filterValues);
    this.apply.emit(filterValues);
  }

  // Method called when Clear Filter button is clicked
  onClearFilter(): void {
    // Reset all field values
    this.fields.forEach(field => {
      if (field.type === 'multiselect') {
        field.value = [];
      } else {
        field.value = null;
      }
    });
    
    // console.log('Filters cleared');
    this.clear.emit();
  }
}
